import { useState } from "react";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import { LucideCircleCheck } from "lucide-react";
import Button from "components/button";
import { Divider, Checkbox } from "antd";

const membersList = [
  { id: 1, name: "Ashley Palma", role: "Senior Developer"},
  { id: 2, name: "Saccharine Elupre", role: "Marketing Manager"},
  { id: 3, name: "Emily Rodriguez", role: "Frontend Developer"},
  { id: 4, name: "James Wilson", role: "HR Specialist"},
  { id: 5, name: "Lisa Anderson", role: "Financial Analyst"},
  { id: 6, name: "David Martinez", role: "DevOps Engineer"},
  { id: 7, name: "Jennifer Lee", role: "UX Designer"},
  { id: 8, name: "Robert Taylor", role: "Sales Director"},
  { id: 9, name: "Acee Cayanan", role: "Creative Director"},
];

export default function SelectTeamCard({ selectedMembers, setSelectedMembers }) {
  const [search, setSearch] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState(0);

  const filteredMembers = membersList.filter(
    (member) =>
      member.name.toLowerCase().includes(search.toLowerCase()) ||
      member.role.toLowerCase().includes(search.toLowerCase())
  );

  const isSelected = (member) => selectedMembers.some(m => m.id === member.id);

  const toggleMember = (member) => {
    setSelectedMembers(prev =>
      isSelected(member)
        ? prev.filter(m => m.id !== member.id)
        : [...prev, member]
    );
  };

  const selectAll = () => {
    if (selectedMembers.length === filteredMembers.length) {
      setSelectedMembers([]);
    } else {
      setSelectedMembers(filteredMembers);
    }
  };

  return (
    <div className="space-y-4">
      <SearchBar
        placeholder="Search by name, position or ID..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <SelectOption
        placeholder="All Departments"
        options={[
          { label: "All Departments", value: 0 },
          { label: "Engineering", value: 1 },
          { label: "Marketing", value: 2 },
          { label: "HR", value: 3 },
          { label: "Finance", value: 4 },
          { label: "Design", value: 5 },
          { label: "Sales", value: 6 },
        ]}
        value={selectedDepartment}
        onChange={(value) => setSelectedDepartment(value)}
      />

      <Button
        onClick={selectAll}
        className="h-4 w-full flex items-center justify-center border-2 gap-1 transition-colors duration-200
                  hover:border-green-500 hover:bg-green-50"
      >
        <LucideCircleCheck size={16} />
        <span className="flex text-[13px]">
          {selectedMembers.length === filteredMembers.length ? "Deselect All" : "Select All"}
        </span>
      </Button>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="h-[300px] overflow-auto space-y-3 mt-2">
        {filteredMembers.map((member) => {
          const selected = isSelected(member);

          return (
            <div
              key={member.id}
              className={`flex items-center gap-3 p-2.5 rounded-xl border-2 cursor-pointer transition-all
                ${selected
                  ? "border-green-500 bg-green-50"
                  : "border-slate-200 hover:border-emerald-300 hover:bg-slate-50"
                }`}
              onClick={() => toggleMember(member)}
            >
              <Checkbox
                checked={selected}
                onChange={() => toggleMember(member)}
                className="emerald-checkbox"
              />
              <div
                className={`flex items-center justify-center w-10 h-10 border-2 border-white rounded-full text-[11px] font-semibold transition-all duration-300
                  ${selected
                    ? "bg-gradient-to-br from-emerald-500 to-cyan-500 text-white"
                    : "bg-emerald-100 text-emerald-700"
                  }`}
              >
                {member.name
                  ? member.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                  : "?"}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-[13px] truncate">{member.name}</p>
                <p className="text-[11px] text-muted-foreground truncate">{member.role}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
